import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal, schemaId } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#ehegattenunterhalt-sonstige-einnahme-einkunft-aus-kapitalverm%C3%B6gen-und-unbefristete-zusatzrente

	{
		"betragMonatlich": schemaBigDecimal,
		"gehoertZuAntragsteller": "ANTRAGSTELLER_1" | "ANTRAGSTELLER_2"
	}

*/
export const schemaEuropaceEhegattenunterhaltSonstigeEinnahmeEinkunftAusKapitalvermoegenUndUnbefristeteZusatzrente =
    z.object({
        betragMonatlich: z.optional(schemaBigDecimal),
        europaceId: z.optional(z.string().min(1)),
        gehoertZuAntragsteller: z.optional(z.nativeEnum(APPLICANT_ATTRIBUTIONS)),
        id: schemaId,
    });

export type SchemaEuropaceEhegattenunterhaltSonstigeEinnahmeEinkunftAusKapitalvermoegenUndUnbefristeteZusatzrente =
    z.infer<
        typeof schemaEuropaceEhegattenunterhaltSonstigeEinnahmeEinkunftAusKapitalvermoegenUndUnbefristeteZusatzrente
    >;
